<template>
  <div id="new-layout">
    <Layout>
      <Sider
        v-if="showNavigation()"
        :class="{ hideSideBar: hideSideBar }"
        style="width: 230px; min-width: 230px"
        theme="light"
      >
        <div class="logo-wrapper">
          <img width="160px" alt="Rentalios logo" src="@/assets/logo.svg" />
        </div>
        <Menu class="menu-wrapper" v-model="currentMenu">
          <MenuItem :key="menu.title" v-for="(menu, index) in menus">
            <router-link class="menu-item-wrapper" :to="menu.path">
              <div>
                <img
                  class="menu-icon"
                  :alt="menu.title"
                  :src="getMenuIcon(index)"
                />
              </div>
              <div>
                {{ menu.title }}
              </div>
            </router-link>
          </MenuItem>
          <MenuItem>
            <div @click="doLogout" class="menu-item-wrapper">
              <div>
                <img
                  class="menu-icon"
                  alt="log-out"
                  src="@/assets/sideBarIcons/log-out.svg"
                />
              </div>
              <div>Logout</div>
            </div>
          </MenuItem>
        </Menu>
      </Sider>
      <Layout>
        <OldHeader v-if="showNavigation()" />

        <Content> <slot></slot> </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import { Layout, Menu } from 'ant-design-vue'

import OldHeader from './Header.vue'
import { auth } from '../Firebase'

const { Content, Sider } = Layout
const MenuItem = Menu.Item

export default {
  name: 'NewLayout',
  components: {
    Layout,
    OldHeader,
    Menu,
    MenuItem,
    Content,
    Sider
  },
  data() {
    return {
      hideSideBar: false,
      menuOpen: true,
      crossVisible: false,
      smallDevice: false,
      currentMenu: ['Rentals'],
      menus: [
        {
          title: 'Rentals',
          path: '/rentals/calendar',
          activeIcon: require('@/assets/selectedSideBarIcons/rentals.svg'),
          inActiveIcon: require('@/assets/sideBarIcons/rentals.svg')
        },
        // {
        //   title: 'Heatmap',
        //   path: '/heatmap',
        //   activeIcon: require('@/assets/selectedSideBarIcons/heatmap.svg'),
        //   inActiveIcon: require('@/assets/sideBarIcons/heatmap.svg')
        // },
        {
          title: 'Report',
          path: '/report',
          activeIcon: require('@/assets/selectedSideBarIcons/report.svg'),
          inActiveIcon: require('@/assets/sideBarIcons/report.svg')
        },
        {
          title: 'Properties',
          path: '/listings/properties',
          activeIcon: require('@/assets/selectedSideBarIcons/properties.svg'),
          inActiveIcon: require('@/assets/sideBarIcons/properties.svg')
        },
        {
          title: 'Tasks',
          path: '/chores/calendar',
          activeIcon: require('@/assets/selectedSideBarIcons/chores.svg'),
          inActiveIcon: require('@/assets/sideBarIcons/chores.svg')
        },
        {
          title: 'Contacts',
          path: '/contacts/housemates',
          activeIcon: require('@/assets/selectedSideBarIcons/staff.svg'),
          inActiveIcon: require('@/assets/sideBarIcons/staff.svg')
        },
        {
          title: 'Messages',
          path: '/ai-agent',
          activeIcon: require('@/assets/messages.svg'),
          inActiveIcon: require('@/assets/sideBarIcons/messages.svg')
        }
      ]
    }
  },
  methods: {
    setCurrentMenu() {
      let menu = ['Rentals']
      let currentPath = this.$router.currentRoute.path
      if (currentPath.includes('rentals')) {
        menu = ['Rentals']
      } else if (currentPath.includes('heatmap')) {
        menu = ['Heatmap']
      } else if (currentPath.includes('report')) {
        menu = ['Report']
      } else if (
        currentPath.includes('listings') ||
        currentPath.startsWith('/properties')
      ) {
        menu = ['Properties']
      } else if (currentPath.includes('chores')) {
        menu = ['Tasks']
      } else if (currentPath.includes('contacts')) {
        menu = ['Contacts']
      } else if (currentPath.includes('ai-agent')) {
        menu = ['Messages']
      }
      this.currentMenu = menu
    },
    isPublic() {
      let urlPath = window.location.pathname
      if (urlPath.includes('publiclList') || urlPath.includes('notfound')) {
        return false
      } else {
        return true
      }
    },
    showNavigation() {
      if (!this.isPublic()) return false
      return !this.$route.path.startsWith('/voice-note-chat')
    },
    routeTo(path) {
      this.$router.replace({ path: path })
    },
    async doLogout() {
      this.hideSideBar = true
      auth.signOut()
      await this.delay(1000)
      this.$router.replace({ name: 'signin' })
    },
    delay(time) {
      return new Promise((resolve) => setTimeout(resolve, time))
    },
    getMenuIcon(menuIndex) {
      const menu = this.menus[menuIndex]
      if (menu.title === this.currentMenu[0]) {
        return menu.activeIcon
      }
      return menu.inActiveIcon
    },
    onResize() {
      this.menuOpen = false
      this.width = window.innerWidth

      if (this.width > 768) {
        this.smallDevice = false
        this.menuOpen = true
      } else {
        this.smallDevice = true
      }
    }
  },
  mounted() {
    this.onResize()
    if (this.$router.currentRoute.name == 'signin') {
      this.hideSideBar = true
    }
    this.setCurrentMenu()
  },
  created() {
    window.addEventListener('resize', this.onResize)
    if (this.$router.currentRoute.name == 'signin') {
      this.hideSideBar = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
.logo-wrapper {
  padding-top: 24px;
  padding-bottom: 24px;
}
.menu-item-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin: 0 0 0 25%;
  color: #80a986;
}
.menu-item-wrapper:hover {
  color: #80a986;
}
::v-deep .ant-layout-sider {
  background-color: #00530d;
}
::v-deep .ant-layout.ant-layout-has-sider {
  height: 100%;
}
::v-deep .ant-menu {
  background-color: transparent;
  border: black;
  display: flex;
  flex-direction: column;
}
::v-deep .ant-menu-item {
  height: 54px;
  line-height: 54px;
}
::v-deep .ant-menu-item-selected .menu-item-wrapper {
  color: #ffffff;
}
::v-deep .ant-menu-item-selected {
  background-color: #196425 !important;
}

::v-deep .ant-menu-item-active {
  background-color: #196425 !important;
}

#new-layout {
  height: 100%;
}
.hideSideBar {
  display: none !important;
}
::v-deep .ant-menu > li:last-child {
  margin-bottom: auto;
  margin-top: auto;
}
</style>
